/*eslint-disable*/
import React,{ useState, useEffect } from "react";
// react components used to create a calendar with events on it
import { Calendar as BigCalendar, momentLocalizer } from "react-big-calendar";
// dependency plugin for react-big-calendar
import moment from "moment";
// react component used to create alerts
import SweetAlert from "react-bootstrap-sweetalert";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import Heading from "components/Heading/Heading.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import {Animated} from "react-animated-css";
import styles from "assets/jss/material-dashboard-pro-react/components/buttonStyle.js";
import { events as calendarEvents } from "../../Calendar/CalendarEvent.js";
import { connect } from 'react-redux';
import Service from 'Utils/Service';
import {mapStateToProps , mapDispatchToPros} from '../../../Utils/MapStateDispatchProps.js'
const localizer = momentLocalizer(moment);

const useStyles = makeStyles(styles);

function Calendar(props) {
  const classes = useStyles();
  const [events, setEvents] = React.useState(calendarEvents);
  const [alert, setAlert] = React.useState(null);
  const [data, setData] = React.useState([]);
  useEffect(() => {
    //axios
    // fetch("https://reqres.in/api/users?page=1")
    //   .then((response) => response.json())
    //   .then((result) => {
        // console.log(props.data.user_id);
    //     setData(result.data);
    //   })
    const postData = {
      status:'All',
      id:props.data.id,
      user_id:props.data.user_id,
      role_id:props.data.role_id,
      from_date:'',
      to_date:''
    };
    new Service().apiCall('SchedulePlanner/GetScheduleCalendar',postData).then(response =>
    {
      if (response.data!='') 
      {    
        console.log(response.data); 
        setData(response.data);           
        // this.setState({todays_schedule_count:response.data.todays_schedule_count});
        // this.setState({upcoming_schedule_count:response.data.upcoming_schedule_count});
        // this.setState({present_week_met_count:response.data.present_week_met_count});
        // this.setState({present_week_rescheduled_count:response.data.present_week_rescheduled_count});
      }
      else{
        setData([]);
      }
    }).catch(error => {
      alert("error.response.data.message");
    });
  });


  const selectedEvent = event => {
    // window.alert(event.title);
    setAlert(
      <SweetAlert
        // input
        showCancel
        style={{ display: "block", marginTop: "-100px" }}
        title={event.title}
        onConfirm={e => addNewEvent(e, slotInfo)}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.success}
        cancelBtnCssClass={classes.button + " " + classes.danger}
      >
      {event.custom}
      </SweetAlert>
    );
  };
  const addNewEventAlert = slotInfo => {
    // setAlert(
    //   <SweetAlert
    //     // input
    //     showCancel
    //     style={{ display: "block", marginTop: "-100px" }}
    //     title="Input something"
    //     onConfirm={e => addNewEvent(e, slotInfo)}
    //     onCancel={() => hideAlert()}
    //     confirmBtnCssClass={classes.button + " " + classes.success}
    //     cancelBtnCssClass={classes.button + " " + classes.danger}
    //   />
    // );
  };
  const addNewEvent = (e, slotInfo) => {
    var newEvents = events;
    newEvents.push({
      title: e,
      start: slotInfo.start,
      end: slotInfo.end
    });
    setAlert(null);
    setEvents(newEvents);
  };
  const hideAlert = () => {
    setAlert(null);
  };
  const eventColors = event => {
    var backgroundColor = "event-";
    event.color
      ? (backgroundColor = backgroundColor + event.color)
      : (backgroundColor = backgroundColor + "default");
    return {
      className: backgroundColor
    };
  };
  return (
    <div>
      <Animated  className="Animated" animationIn="slideInRight" animationOut="slideOutLeft" > 
        {/* <Heading
          textAlign="center"
          title="React Big Calendar"
          category={ <span> </span> }
        /> */}
        {alert}
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={10}>
            <Card>
              <CardBody calendar>
                <BigCalendar
                  selectable
                  localizer={localizer}
                  events={data}
                  defaultView="month"
                  scrollToTime={new Date(1970, 1, 1, 6)}
                  defaultDate={new Date()}
                  // onSelectEvent={event => selectedEvent(event)}
                  // onSelectSlot={slotInfo => addNewEventAlert(slotInfo)}
                  eventPropGetter={eventColors}
                />
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </Animated>		
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToPros)(Calendar);
